import { Component } from '@angular/core';

@Component({
	selector: 'app-backoffice-layout',
	templateUrl: './backoffice-layout.component.html',
	styleUrls: ['./backoffice-layout.component.less'],
})
export class BackofficeLayoutComponent {}
